export const CREATE_PARTNER = 'CREATE_PARTNER';
export const FETCH_PARTNERS = 'FETCH_PARTNERS';
export const FETCH_PARTNER = 'FETCH_PARTNER';
export const DELETE_PARTNER = 'DELETE_PARTNER';
export const SAVE_ERROR = 'SAVE_ERROR';